import * as action from './SettingAction'
import { default as actionType } from './SettingActionType'
import { default as reducer } from './SettingReducer'

export const SETTING = {
  action,
  actionType,
  reducer
}
